/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_EmptyInputs */

const vi_camera_attach_empty = /** @type {(inputs: Camera_Attach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có camera nào khác để gắn. Thêm camera mới cho vùng này, hoặc thêm ở màn Danh sách camera.`)
};

/**

* @param {Camera_Attach_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_empty = /** @type {((inputs?: Camera_Attach_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_empty(inputs)
});